import type { FormEvent } from "react";
import { CircleNotch, LockKey, WarningCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";

interface PlatformLockWallProps {
  password: string;
  onPasswordChange: (value: string) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  isSubmitting: boolean;
  error: string;
}

export function PlatformLockWall({
  password,
  onPasswordChange,
  onSubmit,
  isSubmitting,
  error,
}: PlatformLockWallProps) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-md rounded-lg border bg-card p-6 shadow-sm sm:p-8">
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between gap-4">
            <Logo className="h-7 w-auto text-foreground" />
            <div className="flex size-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <LockKey weight="fill" />
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <h1
              className="text-2xl font-semibold leading-tight text-foreground"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              Platforma je trenutno zatvorena
            </h1>
            <p className="text-sm leading-6 text-muted-foreground">
              Unesite platform lock šifru za nastavak.
            </p>
          </div>

          <form className="flex flex-col gap-4" onSubmit={onSubmit}>
            <div className="flex flex-col gap-2">
              <Label htmlFor="platform-lock-password">Šifra</Label>
              <Input
                id="platform-lock-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => onPasswordChange(event.target.value)}
                aria-invalid={Boolean(error)}
              />
            </div>

            {error ? (
              <div className="flex items-start gap-2 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive">
                <WarningCircle className="mt-0.5 shrink-0" />
                <span>{error}</span>
              </div>
            ) : null}

            <Button type="submit" disabled={isSubmitting || !password.trim()}>
              {isSubmitting ? (
                <CircleNotch className="animate-spin" data-icon="inline-start" />
              ) : (
                <LockKey data-icon="inline-start" />
              )}
              Otključaj
            </Button>
          </form>
        </div>
      </div>
    </main>
  );
}
